import React from "react";
import NumberFormat from "react-number-format";

import { getRange } from "aible";

import {
  BarChart,
  Bar,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  ZAxis,
  ReferenceLine,
  ResponsiveContainer,
  Label,
  Cell
} from "recharts";

import { graphSort } from "containers/Gallery/GalleryReducer";

import styles from "./style.module.css";

class CustomToolTip extends React.Component {
  /*
  componentDidUpdate(prevProps) {
    const { label, payload, updateHoverValue, active } = this.props;

    if(active === false && prevProps.active === true) {
      updateHoverValue(undefined);
    }

    if (label && prevProps.label && label !== prevProps.label) {
      const field =
        payload && payload[0] && payload[0].payload
          ? payload[0].payload.field
          : undefined;
      const value =
        payload && payload[0] && payload[0].payload
          ? payload[0].payload.value
          : undefined;

      //this.props.updateHoverValue("ewewew");

      if (field && value) {
        updateHoverValue({
          field: field,
          value: value
        });
      }
    }
  }
  */

  render() {
    const { active, payload, isQuickRun, hasProb, label, successStrings, threshold } = this.props;
    if (!active || !payload || !payload[0] || !payload[0].payload) {
      return null;
    }

    return payload.length === 1 ? (
      <div className={styles.cTooltip}>
        <div className={styles.tModel}>
          {payload[0].payload.value
            ? payload[0].payload.valueLabel !== undefined
              ? payload[0].payload.valueLabel.label
              : payload[0].payload.value
            : payload[0].payload.model}
        </div>
        {payload[0].payload.model && (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{"Model :"}</div>
            <strong>{payload[0].payload.model}</strong>
          </div>
        )}
        {payload[0].payload.field && payload[0].payload.valueLabel === undefined && (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{payload[0].payload.field + ": "}</div>
            <strong>{payload[0].payload.value}</strong>
          </div>
        )}
        {hasProb ? (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{"Recommendation: "}</div>
            <strong>
              {payload[0].payload.probability !== undefined && payload[0].payload.probability >= threshold
                ? "Pursue this opportunity"
                : "Ignore this opportunity"}
            </strong>
          </div>
        ) : (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{"Prediction: "}</div>
            <strong>{successStrings.positive + " "}</strong>
            <NumberFormat
              value={payload[0].payload.prediction ? Number(payload[0].payload.prediction).toFixed(2) : ""}
              displayType={"text"}
              thousandSeparator={true}
              style={{ marginLeft: "5px" }}
            />
          </div>
        )}
        {hasProb && (
          <div className={styles.tBody}>
            <div className={styles.tLabel}>{"Prediction Score: "}</div>
            <strong>
              <NumberFormat
                value={payload[0].payload.probability ? Number(payload[0].payload.probability).toFixed(2) : ""}
                displayType={"text"}
                thousandSeparator={true}
              />
            </strong>
          </div>
        )}
      </div>
    ) : (
      <div className={styles.cTooltip}>
        <div className={styles.tModel}>{payload[0].payload.value}</div>
        <div className={styles.tBody}>
          <div className={styles.tLabel}>{"Prediction: "}</div>
          <strong>
            {payload[0].payload.prediction && payload[0].payload.prediction === "1.0"
              ? successStrings.positive
              : successStrings.negative}
          </strong>
        </div>
        {payload.map((p, index) => (
          <div className={styles.tBody} key={index}>
            <div className={styles.tLabel}>{p.name + ": "}</div>
            <strong>
              <NumberFormat value={p.value} displayType={"text"} thousandSeparator={true} />
            </strong>
          </div>
        ))}
      </div>
    );
  }
}

const CustomLabel = (props) => {
  const { active, payload, label } = props;

  return (
    <text textAnchor="start" className={styles.aLabel}>
      <tspan
        x={
          props.position === "insideTopLeft"
            ? props.value
              ? 250 / props.value.length
              : 20
            : props.viewBox.x + props.viewBox.width / 2 - 33
        }
        y={props.viewBox.y + props.offset}
      >
        {props.value}
      </tspan>
    </text>
  );
};

const RenderLegend = (props) => {
  const { successStrings } = props;

  return (
    <div className={styles.legendHolder}>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.positive} />
        <div>{successStrings.positive}</div>
      </div>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.negative} />
        <div>{successStrings.negative}</div>
      </div>
    </div>
  );
};

function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  const retVal = num.toString().match(re);
  return retVal ? reVal[0] : num;
}

class MaxChart extends React.Component {
  findValueOption(value) {
    const { valueOptions } = this.props;

    return valueOptions?.find((vOption) => {
      let pValue = Number(value);
      if (value === "inf") {
        return vOption.max === Infinity;
      }
      if (value === "-inf") {
        return vOption.min === -Infinity;
      }
      return pValue <= vOption.max && pValue > vOption.min;
    });
  }

  render() {
    const { isQuickRun, outcome, prediction, threshold, successStrings, updateHoverValue, valueOptions } = this.props;

    let yAxisTickLength = 0;

    let retPrediction = prediction.map((p) => {
      const valueLabel = this.findValueOption(p.value);
      yAxisTickLength = Math.max(yAxisTickLength, valueLabel?.label?.length ?? 0);
      return {
        ...p,
        valueLabel: valueLabel,
        value: p.value === "" ? "I Don't Know" : p.value,
        color: p.prediction && Number(p.prediction) < 0 ? "#F8CD7E" : "#7e69d7"
      };
    });

    retPrediction = graphSort(retPrediction, "value").reverse();

    const hasField = retPrediction && retPrediction.length > 0 && retPrediction[0].field;
    const hasProb = retPrediction && retPrediction.length > 0 && retPrediction[0].probability !== undefined;

    const xLabel = hasField ? retPrediction[0].field : "Model";
    const yLabel = hasProb ? "Prediction Score" : "Predicted " + outcome;

    const yDataMin = Math.min.apply(
      Math,
      retPrediction.map((p) => (hasProb ? p.probability : p.prediction))
    );
    const yDataMax = Math.max.apply(
      Math,
      retPrediction.map((p) => (hasProb ? p.probability : p.prediction))
    );
    const yDelta = yDataMax - yDataMin;

    const yOffset = 0.001;

    const yDomain = getRange(yDataMin, yDataMax);

    let values = {};
    let models = {};
    let isMax = false;

    for (const p of retPrediction) {
      if (p.value) {
        isMax = true;

        values[p.value]
          ? (values[p.value][p.model] = p.probability)
          : (values[p.value] = {
              [p.model]: p.probability,
              value: p.value,
              isSpread: true
            });
      }

      models[p.model] = true;
    }

    isMax = Object.keys(values).length > 1;

    let maxChars = xLabel ? (xLabel.length > 10 ? xLabel.length - 10 : Math.ceil(xLabel.length / 2)) : 0;

    retPrediction &&
      retPrediction.forEach((p) => {
        const val = isMax ? p.value : p.model;

        if (val && val.toString().length > maxChars) {
          maxChars = val.toString().length;
        }
      });

    const colors = [
      "#512F77",
      "#472F77",
      "#3E2F77",
      "#342F77",
      "#2F3377",
      "#2F3D77",
      "#2F4777",
      "#5B2F77",
      "#642F77",
      "#6E2F77",
      "#772F77",
      "#772F6D"
    ];

    if (retPrediction.length === 0) {
      return <div className={styles.errorMsgHolder}>{"Error running Prediction, please try again."}</div>;
    }

    return (
      <div className={styles.pChart} id="pChart" style={{ height: "300px", marginBottom: "20px" }}>
        <div className={styles.title} style={{ textAlign: "center", marginBottom: "10px" }}>
          {outcome + " Prediction"}
        </div>
        <ResponsiveContainer>
          <BarChart
            margin={{
              top: 0,
              right: 10,
              bottom: 20,
              left: maxChars * 3
            }}
            layout="vertical"
            data={retPrediction}
            onClick={() => {}}
          >
            <YAxis
              width={yAxisTickLength > 0 ? Math.floor(yAxisTickLength * 1.6) : undefined}
              type="category"
              dataKey={isMax ? "value" : "model"}
              name={xLabel}
              tickFormatter={(tick) => {
                const valueOption = this.findValueOption(tick);
                const fieldLabel = valueOption?.field;
                const valueLabel = valueOption?.label?.substring(`${fieldLabel}: `.length);
                if (valueOption === undefined || fieldLabel === undefined || valueLabel === undefined) {
                  return tick.toLocaleString();
                }
                const MORE_THAN = "more than ";
                if (valueLabel.substring(0, MORE_THAN.length) === MORE_THAN) {
                  return valueLabel.substring(MORE_THAN.length - 1).toLocaleString();
                }
                return valueLabel.toLocaleString();
              }}
              interval={yAxisTickLength > 0 ? Math.floor(valueOptions.length / 4) : undefined}
            >
              <Label value={xLabel} position={"top"} />
            </YAxis>
            <XAxis
              type="number"
              dataKey={hasProb ? "probability" : "prediction"}
              name={yLabel}
              unit={hasProb ? "" : ""}
              tickFormatter={(tick) => (tick ? tick.toFixed(2) : "")}
              domain={yDomain}
            >
              <Label value={yLabel} offset={0} position="bottom" />
            </XAxis>
            <ReferenceLine x={0} stroke="#000" />
            {hasProb && <ZAxis dataKey="prediction" type="number" />}
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip
              content={
                <CustomToolTip
                  successStrings={successStrings}
                  hasProb={hasProb}
                  updateHoverValue={(val) => updateHoverValue(val)}
                  isQuickRun={isQuickRun}
                  threshold={threshold}
                />
              }
            />
            {isMax ? (
              <Bar dataKey={hasProb ? "probability" : "prediction"} key={hasProb ? "probability" : "prediction"}>
                {retPrediction.map((p, index) => (
                  <Cell key={`cell-${index}`} fill={p.color} />
                ))}
              </Bar>
            ) : (
              <Bar dataKey={hasProb ? "probability" : "prediction"}>
                {retPrediction.map((p, index) => (
                  <Cell key={`cell-${index}`} fill={p.color} />
                ))}
              </Bar>
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default MaxChart;
